class ApiMethods {
    static async apiRequest(method, url, accessToken, body = null) {
        const options = {method: method, headers: {Authorization: `Bearer ${accessToken}`}};
        if (body) {
            options.headers['Content-Type'] = 'application/json';
            options.body = JSON.stringify(body);
        }

        const response = await fetch(
            `${process.env.REACT_APP_KEYNOME_API_URL_BASE}/${url}`,
            options
        );

        if (!response.ok) {
            const errorMessage = await response.text();
            throw new Error(`Error: ${response.status} ${response.statusText} ${errorMessage}`);
        }

        if (response.ok && response.status === 204) {
            return;
        }

        const jsonResponse = await response.json()
        return jsonResponse;
    }

    static async get(url, accessToken) {
        return (await this.apiRequest('GET', url, accessToken)).data;
    }
    
    static async get_with_included(url, accessToken) {
        return await this.apiRequest('GET', url, accessToken);
    }

    static async post(url, accessToken, body) {
        return (await this.apiRequest('POST', url, accessToken, body)).data;
    }

    static async put(url, accessToken, body) {
        return (await this.apiRequest('PUT', url, accessToken, body)).data;
    }
}

export default ApiMethods;
